import { HoverCard, HoverCardProps } from '@radix-ui/react-hover-card';

export const SelectSubMenu = (props: Omit<HoverCardProps, 'openDelay' | 'closeDelay'>) => (
  <HoverCard openDelay={0} closeDelay={0} {...props} />
);
